const PlantConstants = {
  ADD_NEW_PLANT_SUCCESS: "ADD_NEW_PLANT_SUCCESS",
  ADD_NEW_PLANT_FAILURE: "ADD_NEW_PLANT_FAILURE",
  UPDATE_PLANT_SUCCESS: "UPDATE_PLANT_SUCCESS",
  UPDATE_PLANT_FAILURE: "UPDATE_PLANT_FAILURE",
  ADD_PLANT_WEBADMIN_SUCCESS: "ADD_PLANT_WEBADMIN_SUCCESS",
  ADD_PLANT_WEBADMIN_FAILURE: "ADD_PLANT_WEBADMIN_FAILURE",
  DELETE_PLANT_SUCCESS: "DELETE_PLANT_SUCCESS",
  DELETE_PLANT_FAILURE: "DELETE_PLANT_FAILURE",
};

export default PlantConstants;
